import { useCallback } from "react";
import { FlowActions } from "../../stores/flowStore";
export const useSendFlow = () => {
  return _temp;
};
function _temp(t0) {
  const {
    onBack
  } = t0 === undefined ? {} : t0;
  FlowActions.startFlow({
    type: "send",
    onBack
  });
}